import { FC } from './Services/FeathersClient'

export const downloadFile = async (fileName, fileContent, isEncrypted) => {
  try {
    let decodedFile = ''

    if (isEncrypted) {
      decodedFile = await FC.client.service('crypt').get({ method: 'decrypt', string: fileContent })
    } else {
      // eslint-disable-next-line
      decodedFile = atob(fileContent)
    }

    const byteArray = new Uint8Array(decodedFile.length)
    for (let i = 0; i < decodedFile.length; i++) {
      byteArray[i] = decodedFile.charCodeAt(i)
    }

    // eslint-disable-next-line
    const blob = new File([byteArray], { type: 'application/octet-stream' })
    const link = document.createElement('a')
    link.href = URL.createObjectURL(blob)
    link.download = fileName
    link.click()
  } catch (err) {
    console.error('Errore durante il download del file:', err)
  }
}

export const mapDropdown = (value) => {
  return value === 'SI'
}


export const truncateString = (str, maxLength = 31) => {
  if (str.length <= maxLength) return str;

  const charsToShow = maxLength - 3;  
  const front = Math.ceil(charsToShow / 2);
  const back = Math.floor(charsToShow / 2);

  return str.slice(0, front) + "..." + str.slice(str.length - back);
};

const base64ToBytes = (value) => {
  const clean = String(value).replace(/\s/g, '')
  if (!clean.length) return null
  try {
    const binary = atob(clean)
    const bytes = new Uint8Array(binary.length)
    for (let i = 0; i < binary.length; i++) {
      bytes[i] = binary.charCodeAt(i)
    }
    return bytes
  } catch {
    return null
  }
}

/**
 * Decodifica base64 per visualizzazione: prova UTF-8, se fallisce mostra latin1 (byte raw).
 * Cosi file UTF-8 (come i PIC attuali) mostrano €/è correttamente,
 * e file con byte non-UTF-8 non perdono dati.
 */
export const decodeFileContentForDisplay = (content) => {
  if (content == null || content === '') return ''

  const bytes = base64ToBytes(content)
  if (bytes) {
    try {
      return new TextDecoder('utf-8', { fatal: true }).decode(bytes)
    } catch {
      return Array.from(bytes, (b) => String.fromCharCode(b)).join('')
    }
  }

  return typeof content === 'string' ? content : String(content)
}
